const $$splitComponentImporter = () => import('/app/src/routes/test.$token.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/test/$token")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface ActivePayload {
  status: "active";
  clientFirstName: string;
  snapshotName: string;
  snapshotQuestions: TestQuestion[];
  expiresAt: string;
}
type Payload = ActivePayload | {
  status: "expired";
} | {
  status: "submitted";
};
type Phase = "intro" | "filling" | "submitted" | "expired" | "already";